import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Navigate, Routes, Outlet } from 'react-router-dom';
import AuthService from '../auth/AuthService';
import { AppLoading } from '../loaders/loaders';
import appConstants from '../appConstants';
import GlobalRouteComponents from '../components/GlobalRouteComponents';


const RouteRendererComponent = lazy(() => import('./routeRenderer'));
const PageNotFound = lazy(() => import('../components/PageNotFound'));
const ServerError = lazy(() => import('../components/PageNotFound/ServerError'));
const AccessDenied = lazy(() => import('../components/PageNotFound/AccessDenied'));

const RouteContext = () => {
  const { NAV_URLS } = appConstants;
  const renderModuleRoutes = (moduleName) => (
    <Route key={moduleName} path={moduleName} element={<RouteRendererComponent />} />
  );

  const renderOutletRoutes = (homePath, subModules) => (
    <>
      <Route index element={<Navigate to={homePath} replace />} />
      {subModules.map((moduleName) => renderModuleRoutes(moduleName))}
    </>
  );

  const renderMainRoutes = () => (
    <>
      <Route path={NAV_URLS.HOME} element={<Navigate to={NAV_URLS.IBPLANNING_HOME} replace/>} />
      <Route path={NAV_URLS.IBPLANNING_HOME} element={<Outlet />}>
        {renderOutletRoutes(NAV_URLS.IBPLANNING_SHIPMENTS, NAV_URLS.SUB_MODULES.IBPLANNING)}
      </Route>
      <Route path={NAV_URLS.DISPATCH_HOME} element={<Outlet />}>
        {renderOutletRoutes(NAV_URLS.DISPATCH_ROUTEEXECUTION, NAV_URLS.SUB_MODULES.DISPATCH)}
      </Route>
      <Route path={NAV_URLS.REPORT_HOME} element={<Outlet />}>
        {renderOutletRoutes(NAV_URLS.REPORT_DUPLICATE_CUSTOMERS, NAV_URLS.SUB_MODULES.REPORTS)}
      </Route>
      <Route path={NAV_URLS.SETTINGS} element={<Outlet />} >
        <Route key={NAV_URLS.SETTINGS} index element={<RouteRendererComponent />} />
      </Route>
      <Route path={NAV_URLS.SERVER_ERROR} element={<ServerError />} />
      <Route path={NAV_URLS.ACCESS_DENIED} element={<AccessDenied />} />
      <Route path={NAV_URLS.SHIPMENT_SELECTION} element={<Outlet />} >
        <Route key={NAV_URLS.SHIPMENT_SELECTION} index element={<RouteRendererComponent />} />
      </Route>
      <Route path={NAV_URLS.SHIPMENT_FORECAST} element={<Outlet />} >
        <Route key={NAV_URLS.SHIPMENT_FORECAST} index element={<RouteRendererComponent />} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </>
  );

  if (!AuthService.isLoggedIn()) {
    AuthService.doLogin();
    return null;
  }
  return (
    <Router>
      <Suspense fallback={<AppLoading />}>
        <Routes>{renderMainRoutes()}</Routes>
        <GlobalRouteComponents />
      </Suspense>
    </Router>
  );
};
export default RouteContext;
